import axios from "axios";

const binBlacklistBaseUrl = `${process.env.REACT_APP_BASE_URL}/services/parametrics/api/bin-blacklist`;

export const getBinBlacklist = async (token, filters = {}) => {
  const params = new URLSearchParams();
  if (filters.brand) params.append("brand", filters.brand);
  if (filters.reason) params.append("reason", filters.reason);

  return await axios
    .get(`${binBlacklistBaseUrl}?${params.toString()}`, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => response.data)
    .catch((error) => {
      if (token) return error;
    });
};

export const createBinBlacklist = async (token, body) => {
  return await axios
    .post(binBlacklistBaseUrl, body, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => response)
    .catch((error) => {
      if (token) return error;
    });
};

export const updateBinBlacklist = async (token, bin, body) => {
  return await axios
    .patch(`${binBlacklistBaseUrl}/${bin}`, body, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => response)
    .catch((error) => {
      if (token) return error;
    });
};

export const deleteBinBlacklist = async (token, bin) => {
  return await axios
    .delete(`${binBlacklistBaseUrl}/${bin}`, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => response)
    .catch((error) => {
      if (token) return error;
    });
};
